import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function ThirdParty() {
  return (
    <ScaffoldPage
      title="Third-Party Integrations"
      description="Connect Personic AI with your CRM, analytics, and business tools."
      breadcrumbs={buildBreadcrumbs('/settings/integrations/third-party')}
      plannedFeatures={[
        'Salesforce CRM integration (bi-directional sync)',
        'HubSpot contact enrichment',
        'Google Analytics event forwarding',
        'Slack notifications for key events',
        'Zapier connector for workflow automation',
      ]}
      relatedPages={[
        { label: 'Channel Connections', href: '/settings/integrations/channels' },
        { label: 'Webhooks', href: '/settings/integrations/webhooks' },
      ]}
    />
  )
}
